<template>
    <div class="purchase_part-body row">
        <b-col class="purchase_part-body_col" md="4">
            <div class="my-2">
                <slot name="col1"></slot>
            </div>
        </b-col>
        <b-col class="purchase_part-body_col" md="4">
            <div class="my-2">
                <slot name="col2"></slot>
            </div>
        </b-col>
        <b-col class="purchase_part-body_col" md="4">
            <div class="h-100">
                <slot name="col3"></slot>
            </div>
        </b-col>
    </div>
</template>

<script>
export default {
    name: 'cabinet-fl44-card-body'
};
</script>

<style scoped>
.purchase_part-body {
    padding: 5px 15px;
}

.purchase_part-body_col + .purchase_part-body_col > div::before {
    content: '';
    width: 1px;
    height: 100%;
    position: absolute;
    background-color: #d9d9de;
    left: 0px;
    top: 0px;
}

@media screen and (max-width: 767px) {
    .purchase_part-body {
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -moz-box-orient: vertical;
        -moz-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
    }

    .purchase_part-body_col > div {
        position: relative;
    }

    .purchase_part-body_col > div::before {
        content: '';
        width: 100% !important;
        height: 1px !important;
        top: -12px;
    }

    .hidden-mobile {
        display: none;
    }

    .time_to_end {
        font-size: 12px !important;
        margin-bottom: 0 !important;
    }
}

@media screen and (max-width: 768px) {
    .purchase_part-body_col::before {
        content: '';
        display: none;
    }
}
</style>
